import React from "react";
import "./styles.css";

function Checkbox(props) {
  const [checked, setChecked] = React.useState(false);

  return (
    <div
      style={{
        cursor: "pointer",
        height: 20,
        width: 20,
        border: "2px solid green",
        ...(checked && { background: "green" })
      }}
      onClick={() => setChecked(!checked)}
    >
      {props.children}
    </div>
  );
}

//

const isUndefined = value => typeof value === "undefined";

const useAutoControlled = options => {
  const { defaultValue, initialValue = undefined, value } = options;
  const [state, setState] = React.useState(
    isUndefined(defaultValue) ? initialValue : defaultValue
  );

  return [isUndefined(value) ? state : value, setState];
};

function AutoControlledCheckbox(props) {
  const [checked, setChecked] = useAutoControlled({
    defaultValue: false,
    value: props.checked
  });

  props.debug && console.log("AutoControlledCheckbox: render");

  return (
    <div
      style={{
        cursor: "pointer",
        height: 20,
        width: 20,
        border: "2px solid green",
        ...(checked && { background: "green" })
      }}
      onClick={() => {
        setChecked(!checked);
        props.onChange && props.onChange(!checked);
        props.debug && console.log("AutoControlledCheckbox: onClick");
      }}
    >
      {props.children}
    </div>
  );
}

export default function App() {
  const [checked, setChecked] = React.useState(false);

  return (
    <div className="App">
      <h2>Dumb checkbox, not autocontrolled</h2>
      <p>No way to control it, oops</p>
      <Checkbox />

      <h2>autocontrolled Checkbox</h2>
      <p>
        Has autocontrolled <code>checked prop</code>
      </p>
      <AutoControlledCheckbox />

      <h2>autocontrolled Checkbox</h2>
      <p>In controlled mode with debug, see console</p>
      <AutoControlledCheckbox
        checked={checked}
        debug
        onChange={newChecked => setChecked(newChecked)}
      />
    </div>
  );
}
